<template>
  <div class="notifications-container">
    <notification
      v-for="notification in stack"
      :key="notification.id"
      :type="notification.type"
      :title="notification.title"
      :message="notification.message"
      @onDelete="deleteNotification(notification)"
      @onTimeout="deleteNotification(notification)"
    />
  </div>
</template>

<script>
import store from '../store'
import Notification from './Notification'

export default {
  components: { Notification },
  data () {
    return {
      stack: store.stack
    }
  },
  methods: {
    deleteNotification (notification) {
      store.removeNotification(notification)
    }
  }
}
</script>

<style scoped>
.notifications-container {
  min-width: 300px;
  position: fixed;
  z-index: 9999;
  bottom: 0;
  left: 0;
  padding: 1em;
}
</style>
